/**
 * Export `routes`.
 */

export const routes = {
  carEvaluationBuyer: '/comprar-carro/verificacao-automovel',
  carEvaluationSeller: '/vender-carro/verificacao-automovel',
  contacts: '/contactos',
  faqs: '/faqs',
  faqsCategoria: '/faqs/:slug',
  goodPractices: '/boas-praticas-baterias-electricas',
  home: '/',
  landingPage: '/landingpage',
  legal: '/legal',
  legalDetails: '/legal/:slug',
  prices: '/precos',
  schedule: '/agendar',
  serviceGarantias: '/servicos/garantias',
  serviceScanDeBateria: '/servicos/scan-de-bateria',
  serviceVerificar360: '/servicos/verificar360'
} as const;

/**
 * Export `RouteName` type.
 */

export type RouteName = keyof typeof routes;
